import type { GetProfileTraitsHelper_ProfileFragment } from './getProfileTraits.graphql'

export const getProfileTraits = ({ email }: GetProfileTraitsHelper_ProfileFragment) => ({
  email,
})
